import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Http, Response } from '@angular/http';


import { BaseWebService } from "../shared/services/base-web.service";
import 'rxjs/add/observable/throw';

@Injectable()
export class PatientPaymentService {

    constructor(
        private _basewebservice: BaseWebService
    ) { }

    /*Service to Fetch location list*/
    getLocation = () => {
        return this._basewebservice.request("v1/locations/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    getPatinetPaymentDetails = (searchKey: any, limit: any, offset: any, location: any, payment_type: any, sortParam: any, order: any) => {
        let query = "v1/patient_payment_details/?limit=" + limit + "&offset=" + offset;
        if (searchKey) {
            query = query + "&search=" + searchKey;
        }
        if (location) {
            query = query + "&location_id=" + location;
        }
        if (payment_type) {
            query = query + "&payment_type=" + payment_type;
        }
        if (sortParam && order) {
            query = query + "&sort=" + sortParam + "&order=" + order;
        }
        return this._basewebservice.request(query, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * Function for handling service call errors
     * @param  {Response|any} error contains error data
     */

    handleError(error: Response | any) {
        return Observable.throw(error);
    }
}
